import { useState, useEffect, RefObject } from 'react';

export function useOnScreen(
  element: RefObject<Element>,
  threshold = 200,
  throttleMilliseconds = 20
): boolean {
  const [isVisible, setIsVisible] = useState(false);

  function throttle(func: () => void): () => void {
    let lastTime = 0;
    return () => {
      const now = Date.now();
      if (now - lastTime >= throttleMilliseconds) {
        func();
        lastTime = now;
      }
    };
  }

  const onScroll = throttle(() => {
    if (!element.current) {
      setIsVisible(false);
      return;
    }
    const rect = element.current.getBoundingClientRect();
    const elementCenter = rect.top + rect.height / 2;
    const viewportCenter = window.innerHeight / 2;
    setIsVisible(Math.abs(elementCenter - viewportCenter) < threshold);
  });

  useEffect(() => {
    document.addEventListener('scroll', onScroll, true);
    window.addEventListener('resize', onScroll, true);
    onScroll();
    return () => {
      document.removeEventListener('scroll', onScroll, true);
      window.removeEventListener('resize', onScroll, true);
    };
  }, [element, threshold]);

  return isVisible;
}
